import React from 'react';
import logo from '../../assets/logo-512.png';
import './Footer.css';
import privacyPolicy from '../../assets/documents/Privacy-Policy.pdf';

export default function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-inner">
          {/* Logo */}
          <img src={logo} alt="Logo" className="footer-logo" />

          {/* Menü Linkleri */}
          <ul className="footer-links">
            <li>
              <a href="/#features" className="footer-link">About Us</a>
            </li>
            <li>
              <a href="/#download" className="footer-link">Download Now</a>
            </li>
            <li>
              <a href="mailto:commitoapp@gmail.com" className="footer-link">Contact Us</a>
            </li>
          </ul>

          {/* Çizgi */}
          <div className="footer-line"></div>

          {/* Alt Bilgi */}
          <div className="footer-legal">
            <ul className="legal-links">
              <li>
                <a href={privacyPolicy} download="Privacy-Policy.pdf" className="footer-link">Privacy Policy</a>
              </li>
            </ul>
            <p>Copyright © RealWorks 2024</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
